import { Action } from "redux";
export const END_IMPERSONATION = "END_IMPERSONATION";
export const MUI_DRAWER_IS_OPEN = "MUI_DRAWER_IS_OPEN";

export interface EndImpersonation extends Action {
  type: "END_IMPERSONATION";
}

export interface MuiDrawerIsOpen extends Action {
  type: typeof MUI_DRAWER_IS_OPEN;
  payload: {
    isOpen: boolean;
    width?: number;
  };
}
